module.exports = __webpack_public_path__ + "catalog/items/bathroom/rectangular-bathroom-sink/rectangular-bathroom-sink.svg";